module.exports = __webpack_public_path__ + "static/media/follow-reply.05f200cc.png";